export default {"src":"/_next/static/media/cart-page-shield-tick.6fc87af1.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};